import { useState } from "react";
import moment from "moment";
import { groupReadings, toPayload } from "./group";

function NoData() {
  return (
    <div className="mt-5 h-full w-full" height="112">
      <div className="tremor-Flex-root flex flex-row justify-center items-center w-full h-full border border-dashed rounded-tremor-default border-tremor-border dark:border-dark-tremor-border">
        <div className="text-tremor-default text-tremor-content dark:text-dark-tremor-content p-10">
          No data
        </div>
      </div>
    </div>
  );
}

const ReadingChip = ({ type, value, unit }) => (
  <span className="inline-flex items-baseline gap-1.5 rounded-md bg-tremor-background-subtle px-2.5 py-1 font-mono text-sm dark:bg-dark-tremor-background-subtle">
    <span className="text-tremor-content-subtle dark:text-dark-tremor-content-subtle">
      {type}
    </span>
    <span className="text-tremor-content-strong dark:text-dark-tremor-content-strong">
      {Array.isArray(value) ? value.join(", ") : value}
      {unit ? ` ${unit}` : ""}
    </span>
  </span>
);

function UplinkCard({ uplink }) {
  const [open, setOpen] = useState(false);
  const time = moment(uplink.timestamp);

  return (
    <li className="relative pl-8">
      <span
        className="absolute left-0 top-6 h-2.5 w-2.5 -translate-x-1/2 rounded-full bg-blue-600 ring-4 ring-tremor-background dark:bg-blue-400 dark:ring-dark-tremor-background"
        aria-hidden={true}
      />
      <div className="overflow-hidden rounded-tremor-default border border-tremor-border bg-tremor-background dark:border-dark-tremor-border dark:bg-dark-tremor-background">
        <div className="flex flex-wrap items-center gap-x-6 gap-y-3 px-4 py-3">
          <div className="w-28 shrink-0">
            <div
              className="font-mono font-semibold text-tremor-content-strong dark:text-dark-tremor-content-strong"
              title={time.format("LLL")}
            >
              {time.format("HH:mm")}
            </div>
            <div className="text-xs text-tremor-content dark:text-dark-tremor-content">
              {time.fromNow()}
            </div>
          </div>
          <div className="flex flex-1 flex-wrap gap-2">
            {uplink.readings.map((r) => (
              <ReadingChip key={r.channel} {...r} />
            ))}
          </div>
          <button
            type="button"
            onClick={() => setOpen(!open)}
            className="text-sm text-blue-600 hover:underline dark:text-blue-400"
          >
            {open ? "Hide payload" : "Payload"}
          </button>
        </div>
        {open && (
          <pre className="overflow-x-auto border-t border-tremor-border bg-tremor-background-muted px-4 py-3 font-mono text-xs text-tremor-content-emphasis dark:border-dark-tremor-border dark:bg-dark-tremor-background-muted dark:text-dark-tremor-content-emphasis">
            {JSON.stringify(toPayload(uplink), null, 2)}
          </pre>
        )}
      </div>
    </li>
  );
}

export default function UplinkTimeline({ logs }) {
  const uplinks = groupReadings(logs.readings);

  if (uplinks.length === 0) return <NoData />;

  return (
    <ol className="relative mt-6 ml-1 space-y-3 border-l border-tremor-border dark:border-dark-tremor-border">
      {uplinks.map((uplink) => (
        <UplinkCard key={uplink.timestamp} uplink={uplink} />
      ))}
    </ol>
  );
}
